<template>
    <fieldset :disabled="disabled" style="overflow: visible">
        <legend>{{ title }}</legend>
        <table class="dataTable mergeTable" width="100%">
            <tbody>
                <slot></slot>
            </tbody>
        </table>
    </fieldset>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
}
</script>